import React, {useState, Fragment} from 'react';
import {Popup, Select, Explanation_text, Autocomplete} from '../../../../../../../components';
import Typography from '@material-ui/core/Typography';

export default function Contact_detach_popup(props){
  const[company, setCompany]=useState();
  const[confirm, setConfirm]=useState(false);
  let name=props.contact.first_name; if(props.contact.last_name!=undefined){name=name+props.contact.last_name;}
  return(
    <Popup always_open title={"Does this contact no longer belong here?"} accept_button='Save' handleClose={()=>{setConfirm(false); props.handleClose()}} accept_button_click={()=>{if(confirm==false){setConfirm(true);}else{let array=[]; if(company!=undefined){array.push({contact_id:props.contact.id, company_id:company.id, connected:true, working_contact:true});} array.push({contact_id:props.contact.id, company_id:props.company.id, connected:false}); props.onDetach(props.company.id, {company_contacts:array}); setConfirm(false); props.handleClose();}}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
      {(confirm==true)?
        <Typography varian='caption'>{(company==undefined)?'Are you sure you want to detach this contact?':('Are you sure you want to Move this contact to '+company.name+'?')}</Typography>
        :
        <Fragment>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}><Explanation_text inline text='prospect_contact_detach_popup_warning_text' placeholders={{name:name}}/></Typography></div>
        <div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
        <Autocomplete title='Company' search_url='/api/companies?single_table=true&q=' onSelect={(x)=>{setCompany(x);}}/>
        </div>
        </Fragment>
      }
      </div>
    }/>
  )
}
